import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from '../components/Icon'
import { useUI } from '../store/ui'
import { useSession } from '../store/session'
import { initials, fullName, roleLabel } from '../lib/format'

export function TopBar() {
  const { theme, density, toggleTheme, setDensity, setCmdk } = useUI()
  const me = useSession((s) => s.me)
  const logout = useSession((s) => s.logout)
  const nav = useNavigate()
  const [menu, setMenu] = useState(false)

  const name = me ? fullName(me.firstname, me.lastname, me.email) : ''
  const role = me?.roles[0] ?? ''

  return (
    <header className="topbar">
      <button className="tb-cmdk" style={{ flex: '0 1 440px' }} onClick={() => setCmdk(true)}>
        <Icon name="search" size={15} /> Search accounts, references, screens…
        <kbd>⌘K</kbd>
      </button>

      <div className="tb-right">
        <div className="seg" role="group" aria-label="Density">
          <button className={density === 'compact' ? 'on' : ''} title="Compact" onClick={() => setDensity('compact')}>
            <Icon name="rows" size={15} />
          </button>
          <button className={density === 'comfortable' ? 'on' : ''} title="Comfortable" onClick={() => setDensity('comfortable')}>
            <Icon name="grid" size={15} />
          </button>
        </div>

        <button className="icon-btn" title="Toggle theme" onClick={toggleTheme}>
          <Icon name={theme === 'light' ? 'moon' : 'sun'} />
        </button>

        <button className="icon-btn" title="Alerts">
          <Icon name="notifications" />
          <span className="dot-badge" />
        </button>

        <div style={{ position: 'relative' }}>
        <button className="tb-switch" onClick={() => setMenu((m) => !m)} aria-label="User menu">
          <span className="badge" style={{ background: 'var(--primary-weak)', color: 'var(--primary)' }}>{initials(name)}</span>
          <span className="who">
            {name}
            <small>{roleLabel(role)}</small>
          </span>
          <Icon name="chevD" size={14} />
        </button>
        {menu && (
          <div className="menu" style={{ width: 250, right: 0 }}>
            <div style={{ padding: '8px 9px', borderBottom: '1px solid var(--border)', marginBottom: 6 }}>
              <div style={{ fontWeight: 600 }}>{name}</div>
              <div className="mono" style={{ color: 'var(--text-2)', fontSize: 11 }}>{me?.email}</div>
              <span
                className="chip mt8"
                style={{ color: 'var(--primary)', borderColor: 'transparent', background: 'var(--primary-weak)' }}
              >
                {roleLabel(role)}
              </span>
            </div>
            <button className="menu-item" onClick={() => { setMenu(false); nav('/account') }}>
              <Icon name="user" size={16} /> My account
            </button>
            <button className="menu-item" style={{ color: 'var(--danger)' }} onClick={logout}>
              <Icon name="logout" size={16} /> Sign out
            </button>
          </div>
        )}
        {menu && <div style={{ position: 'fixed', inset: 0, zIndex: 30 }} onClick={() => setMenu(false)} />}
        </div>
      </div>
    </header>
  )
}
